import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Card, Checkbox, DatePicker, Form, Input, Modal, Popconfirm, Select, Switch, TimePicker } from 'antd';
import api from '../../api';
import helpers from '../../helpers'
import scheduleTemplates from '../../data/schedule-templates';
import LoadingSpinner from '../../components/loading-spinner/loading-spinner';
import MoviePicker from '../../components/movie-picker/movie-picker.component';
import CacheRegistry from '../../lib/cache-registry/cache-registry';
import pluralize from 'pluralize';
import FaIcon from '../../components/global/fa-icon/fa-icon';
import MoviePosterImage from '../../components/movie-poster-image/movie-poster-image.component';



class ScheduleEditView extends Component {

  constructor(props) {
    super(props);

    this.movieHelper = helpers.movie;
    this.movieCache = new CacheRegistry();

    let id = _.get(this, 'props.match.params.id', null);
    let sourceScheduleId = _.get(this, 'props.match.params.sourceScheduleId', null);

    let selectedScheduleTemplate = _.get(_.first(scheduleTemplates), 'key') || null;
    // console.log('scheduleTemplates: ');
    // console.log(JSON.stringify(scheduleTemplates, null, 2));

    this.state = {
      scheduleDataLoaded: false,
      theaterDataLoaded: false,
      movieDataLoaded: false,
      groupedTheaterScreens: [],
      loaded: false,
      saving: false,
      id: id,
      sourceScheduleId: sourceScheduleId,
      data: null,
      orgStatus: null,
      theaters: null,
      theaterSortMap: null,
      renderCount: 0,
      selectedScheduleTemplate,
      scheduleTemplates,
    };

    this.onScheduleTemplateChanged = this.onScheduleTemplateChanged.bind(this);
    this.onPopuplateSelectedScheduleTemplateClicked = this.onPopuplateSelectedScheduleTemplateClicked.bind(this);
    this.onDateRangeDatesChanged = this.onDateRangeDatesChanged.bind(this);
    this.onPublishedStatusChanged = this.onPublishedStatusChanged.bind(this);
    this.onManagerNotesChanged = this.onManagerNotesChanged.bind(this);
    this.onShowingMenuClicked = this.onShowingMenuClicked.bind(this);
    this.onShowingMoveUpClicked = this.onShowingMoveUpClicked.bind(this);
    this.onShowingMoveDownClicked = this.onShowingMoveDownClicked.bind(this);
    this.onAddTheaterScreenShowingClicked = this.onAddTheaterScreenShowingClicked.bind(this);
    this.onDeleteTheaterScreenShowingClicked = this.onDeleteTheaterScreenShowingClicked.bind(this);
    this.onShowingTheaterChanged = this.onShowingTheaterChanged.bind(this);
    this.onShowingScreenChanged = this.onShowingScreenChanged.bind(this);
    this.onShowingMovieChanged = this.onShowingMovieChanged.bind(this);
    this.onShowingGeneralDateRangeDatesEnabledChanged = this.onShowingGeneralDateRangeDatesEnabledChanged.bind(this);
    this.onShowingGeneralDateRangeDatesChanged = this.onShowingGeneralDateRangeDatesChanged.bind(this);
    this.onShowingGeneralTimeChanged = this.onShowingGeneralTimeChanged.bind(this);
    this.onShowingGeneralTimeIs3DChanged = this.onShowingGeneralTimeIs3DChanged.bind(this);
    this.onShowingGeneralTimeLabelChanged = this.onShowingGeneralTimeLabelChanged.bind(this);
    this.onShowingGeneralTimeDeleted = this.onShowingGeneralTimeDeleted.bind(this);
    this.onShowingGeneralTimeAdded = this.onShowingGeneralTimeAdded.bind(this);
    this.onShowingExceptionItemIs3DChanged = this.onShowingExceptionItemIs3DChanged.bind(this);
    this.onShowingExceptionItemDateChanged = this.onShowingExceptionItemDateChanged.bind(this);
    this.onShowingExceptionItemTimeChanged = this.onShowingExceptionItemTimeChanged.bind(this);
    this.onShowingExceptionItemTimeLabelChanged = this.onShowingExceptionItemTimeLabelChanged.bind(this);
    this.onShowingExceptionItemTypeChanged = this.onShowingExceptionItemTypeChanged.bind(this);
    this.onShowingExceptionItemAdded = this.onShowingExceptionItemAdded.bind(this);
    this.onShowingExceptionItemDeleted = this.onShowingExceptionItemDeleted.bind(this);

    this.onSaveClicked = this.onSaveClicked.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);
    this.onCancelClicked = this.onCancelClicked.bind(this);
    this.onDeleteClicked = this.onDeleteClicked.bind(this);

    this.invalidateRender = _.throttle(this._invalidateRender.bind(this), 500);

    setTimeout(() => {
      this.invalidateScheduleData();
      this.loadTheaterDataOnce();
      this.loadMovieDataOnce();
    }, 0);
  }

  _invalidateRender() {
    let renderCount = this.state.renderCount + 1;
    this.setState({ renderCount });
  }

  async invalidateScheduleData(forceUpdate = false) {
    let id = this.state.id;
    let sourceScheduleId = this.state.sourceScheduleId;

    let queryId = id || sourceScheduleId || null;
    if (forceUpdate || !this.state.loaded) {
      this.prevQuery = null;
    }
    if (this.prevQuery && _.isEqual(this.prevQuery, queryId)) {
      return false;
    }
    this.prevQuery = queryId;

    let schedule = null;
    let isNewSchedule = true;
    let adjustDays = false;

    if (id) {
      let res = await api.schedules.get(id);
      schedule = _.get(res, 'data') || {};
      isNewSchedule = _.isEmpty(schedule);
    } else if (sourceScheduleId) {
      let res = await api.schedules.get(sourceScheduleId);
      schedule = _.get(res, 'data') || {};
      if (schedule) {
        schedule.id = null;
        schedule.status = 'draft';
      }
    }
    if (!schedule) {
      // add mode, create a new empty schedule
      schedule = new api.models.ScheduleModel();
      schedule.status = 'draft';
      isNewSchedule = true;
    }
    if (isNewSchedule) {
      // by default, grab next upcoming friday
      let tmpStartDate = moment().startOf('isoWeek').day('friday');
      if (tmpStartDate && tmpStartDate.isValid()) {
        let oldStartDate = schedule.daterangeStartMomentValue;
        if (oldStartDate && oldStartDate.isValid()) {
          adjustDays = tmpStartDate.diff(oldStartDate, 'days');
        }

        schedule.daterangeStartMomentValue = tmpStartDate;
        schedule.daterangeEndMomentValue = moment(tmpStartDate).add(6, 'days');
      }
    }

    // console.log('schedule_before: ', schedule);

    schedule = this.patchGeneralShowtimes(schedule);
    // console.log('schedule_after: ', schedule);

    schedule.showtimes = this.setAllGeneralShowtimesDateRanges(schedule.showtimes, schedule.daterangeStartMomentValue, schedule.daterangeEndMomentValue, false, adjustDays);

    let state = { data: schedule, orgStatus: schedule.status, scheduleDataLoaded: true };
    if (this.state.theaterDataLoaded && this.state.movieDataLoaded) {
      state.groupedTheaterScreens = this.createGroupedTheaterScreensData(schedule, this.state.theaters);
      state.loaded = true;
    }


    this.setState(state);
    return true;
  }

  async loadTheaterDataOnce() {
    if (this.theaterDataInit) { return false; }
    this.theaterDataInit = true;

    let q = {};
    q.limit = 10000;
    q.sf = 'sort_index';
    q.so = 'asc';

    let res = await api.theaters.find(q);
    let theaters = _.get(res, 'data') || [];
    theaters = _.map(theaters, v => {
      v.id = _.parseInt(v.id);
      return v;
    });
    let theatersSortMap = _.chain(theaters)
      .keyBy('id')
      .mapValues('sortIndexIntValue')
      .value();
    // console.log('sev theaters: ', theaters);
    // console.log('sev theatersSortMap: ', theatersSortMap);

    let state = { theaters, theatersSortMap, theaterDataLoaded: true };
    if (this.state.scheduleDataLoaded && this.state.movieDataLoaded) {
      state.groupedTheaterScreens = this.createGroupedTheaterScreensData(this.state.data, theaters);
      state.loaded = true;
    }
    this.setState(state);
    return true;
  }

  async loadMovieDataOnce() {
    if (this.movieDataInit) { return; }
    this.movieDataInit = true;

    let movies = [];
    let state = { movies, movieDataLoaded: true };
    if (this.state.scheduleDataLoaded && this.state.theaterDataLoaded) {
      state.groupedTheaterScreens = this.createGroupedTheaterScreensData(this.state.data, this.state.theaters);
      state.loaded = true;
    }
    setTimeout(() => {
      this.setState(state);
    }, 0);
  }

  createGroupedTheaterScreensData(schedule, theaters) {

    let groupedTheaterScreens = [];
    _.each(theaters, theater => {
      _.each(theater && theater.screens, screen => {
        groupedTheaterScreens.push({
          theaterId: theater.id,
          theaterName: theater.name,
          screenId: screen.id,
          screenName: screen.name,
          showtimes: []
        });
      });
    });

    _.each(schedule && schedule.showtimes, v => {
      let tmpItem = _.find(groupedTheaterScreens, { theaterId: v.theaterId, screenId: v.screenId });
      if (!tmpItem) {
        tmpItem = {
          theaterId: v.theaterId,
          theaterName: 'Unknown Theater ' + v.theaterId,
          screenId: v.screenId,
          screenName: 'Unknown Screen ' + v.screenId,
          showtimes: []
        };
        groupedTheaterScreens.push(tmpItem);
      }
      tmpItem.showtimes.push(_.cloneDeep(v));
    });

    return groupedTheaterScreens;
  }

  updateScheduleModelFromGroupedTheaterScreens(schedule, groupedTheaterScreens) {
    // console.log('updateScheduleModelFromGroupedTheaterScreens');

    schedule = _.cloneDeep(schedule || {});
    groupedTheaterScreens = _.cloneDeep(groupedTheaterScreens);

    schedule.showtimes = _.chain(groupedTheaterScreens)
      .map(v1 => {
        v1.showtimes = _.chain(v1.showtimes)
          .map(v2 => {
            v2.generalShowtimes = this._sortShowtimes(v2.generalShowtimes);
            v2.showtimeExceptions = this._sortShowtimeExceptions(v2.showtimeExceptions);

            if (_.isEmpty(v2.generalShowtimes) && _.isEmpty(v2.showtimeExceptions)) {
              v2 = null;
            }
            return v2;
          })
          .compact()
          .sortBy('screenId')
          .value();

        return !_.isEmpty(v1.showtimes)? v1.showtimes: null;
      })
      .flatten()
      .compact()
      .sortBy(v => _.get(this.state.theatersSortMap, v.theaterId))
      .value();

    return schedule;
  }

  getMovie(movieId) {
    let retval = this.movieCache.get(movieId);
    if (!retval) {
      api.movies.get(movieId).then(res => {
        let movie = _.get(res, 'data', null);
        this.movieCache.set(movieId, movie);
        this.invalidateRender();
      });
    }
    return retval;
  }

  getTheater(theaterId) {
    // assumes all theaters have already been loaded
    return _.find(this.state.theaters, { id: theaterId }) || null;
  }

  isAddMode() {
    return !this.state.id;
  }

  isCopyMode() {
    return !!this.state.sourceScheduleId;
  }

  _getTargetStringValue(e, trim = false) {
    let value = _.get(e, 'target.value');
    if (trim) {
      value = _.trim(value);
    }
    if (!value || _.isEmpty(value)) { value = null; }
    return value;
  }

  patchGeneralShowtimes(schedule) {
    // convert all generalShowtimes from an array of strings into an array of time objects
    // ex: ["7:30PM","9:30PM"] => [{ time: "7:30PM" }, { time: "9:30PM" }]
    if (schedule && schedule.showtimes) {
      schedule.showtimes = _.map(schedule.showtimes, showtime => {
        if (showtime && showtime.generalShowtimes) {
          showtime.generalShowtimes = this.patchShowtimeObjects(showtime.generalShowtimes);
        }
        if (showtime && showtime.showtimeExceptions) {
          showtime.showtimeExceptions = this.patchShowtimeObjects(showtime.showtimeExceptions);
        }
        return showtime;
      });
    }
    return schedule;
  }

  patchShowtimeObjects(showtimes) {
    return _.map(showtimes, timeObj => {
      if (_.isString(timeObj)) {
        timeObj = { time: timeObj };
      }
      if (_.has(timeObj, 'is3D')) {
        timeObj.is3D = this._convertToBooleanValue(timeObj.is3D);
      }
      return timeObj;
    });
  }

  setAllGroupedTheaterScreensGeneralShowtimesDateRanges(groupedTheaterScreens, startDate, endDate, forceUpdate = false, adjustDays = false) {
    if (startDate && endDate && startDate.isValid() && endDate.isValid()) {
      groupedTheaterScreens = _.map(groupedTheaterScreens, v => {
        if (v && v.showtimes) {
          v.showtimes = this.setAllGeneralShowtimesDateRanges(v.showtimes, startDate, endDate, forceUpdate, adjustDays);
        }
        return v;
      });
    }
    return groupedTheaterScreens;
  }

  setAllGeneralShowtimesDateRanges(showtimes, startDate, endDate, forceUpdate = false, adjustDays = false) {
    // scan through all showtimes and update the standard date range there as well
    if (startDate && endDate && startDate.isValid() && endDate.isValid()) {
      let startDateStr = this._convertToDateString(startDate);
      let endDateStr = this._convertToDateString(endDate);

      let hasAdjustDays = _.isFinite(adjustDays);
      if (forceUpdate && !hasAdjustDays) { adjustDays = 0; }

      showtimes = _.map(showtimes, (showtime, showtimeIdx) => {
        delete showtime.customStartDate;
        delete showtime.customEndDate;
        if (showtime.customDateRange) {
          if (forceUpdate || hasAdjustDays) {
            showtime.startDate = this._adjustDateStr(showtime.startDate, adjustDays);
            showtime.endDate = this._adjustDateStr(showtime.endDate, adjustDays);
          }
        } else {
          showtime.startDate = startDateStr;
          showtime.endDate = endDateStr;
        }

        if (!_.isEmpty(showtime.showtimeExceptions) && _.isFinite(adjustDays)) {
          showtime.showtimeExceptions = _.map(showtime.showtimeExceptions, v => {
            if (v && v.date) {
              v.date = this._adjustDateStr(v.date, adjustDays);
            }
            return v;
          });
        }

        return showtime;
      });
    }
    return showtimes;
  }

  _adjustDateStr(dateTimeStr, adjustDays = 0) {
    let retval = dateTimeStr;
    let tmpDate = this._convertToMomentDateValue(dateTimeStr)
    if (tmpDate && tmpDate.isValid() && _.isFinite(adjustDays)) {
      tmpDate = tmpDate.add(adjustDays, 'days');
      retval = this._convertToDateString(tmpDate);
    }
    return retval
  }

  onScheduleTemplateChanged(value, option) {
    this.setState({ selectedScheduleTemplate: value })
  }

  onPopuplateSelectedScheduleTemplateClicked() {
    // console.log('onPopuplateSelectedScheduleClicked: ' + this.state.selectedScheduleTemplate);
  }

  onDateRangeDatesChanged(dates, dateStrings, updateAllMatchingShowtimes = true) {
    // console.log('onDateRangeDatesChanged', JSON.stringify({ dates, dateStrings }, null, 2));
    let data = this.state.data;
    let orgStartDate = data && data.daterangeStartMomentValue;

    data.daterangeStartMomentValue = _.nth(dates, 0);
    data.daterangeEndMomentValue = _.nth(dates, 1);

    let newState = { data };
    if (updateAllMatchingShowtimes) {
      let groupedTheaterScreens = this.state.groupedTheaterScreens;
      let startDate = data.daterangeStartMomentValue;
      let endDate = data.daterangeEndMomentValue;

      let adjustDays = false;
      if (orgStartDate && orgStartDate.isValid()) {
        adjustDays = startDate.diff(orgStartDate, 'days', false);
      }

      groupedTheaterScreens = this.setAllGroupedTheaterScreensGeneralShowtimesDateRanges(groupedTheaterScreens, startDate, endDate, false, adjustDays);
      newState.groupedTheaterScreens = groupedTheaterScreens;
    }

    this.setState(newState);
  }

  onPublishedStatusChanged(value) {
    let data = this.state.data;
    if (value) {
      data.status = 'published';
    } else {
      let orgStatus = this.state.orgStatus;
      if (orgStatus === 'published' || orgStatus === 'archived') {
        data.status = 'archived';
      } else {
        data.status = 'draft';
      }
    }
    this.setState({ data });
  }

  onManagerNotesChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.manager_notes = value;
    this.setState({ data });
  }

  onShowingMenuClicked(showing) {

    // TODO: joe- add logic to handle moving between theater/screens...

    let modalOpen = true;
    let modalData = { showing };
    this.setState({ modalOpen, modalData });
  }

  onShowingMoveUpClicked(showing) {
    // TODO: joe- add logic to handle moving between theater/screens...
  }

  onShowingMoveDownClicked(showing) {
    // TODO: joe- add logic to handle moving between theater/screens...
  }

  onAddTheaterScreenShowingClicked(theaterId, screenId) {

    let showing = {
      theaterId: theaterId,
      screenId: screenId,
      movieId: null,
      _dbg_movieTitle: null,
      startDate: this.state.data.daterange_start,
      endDate: this.state.data.daterange_end,
      generalShowtimes: [ { time: '7:30 PM' }, { time: '9:30 PM' } ],
      showtimeExceptions: [],
    };


    let groupedTheaterScreens = this.state.groupedTheaterScreens;

    let tmpItem = _.find(groupedTheaterScreens, { theaterId, screenId });
    if (!tmpItem) {
      let theater = this.getTheater(theaterId);
      let screen = (theater && _.find(theater.screens, { id: screenId })) || null;
      tmpItem = {
        theaterId: theaterId,
        theaterName: (theater && theater.name) || ('Unknown Theater ' + theaterId),
        screenId: screenId,
        screenName: (screen && screen.name) || ('Unknown Screen ' + screenId),
        showtimes: [],
      };
      groupedTheaterScreens.push(tmpItem);
    }

    tmpItem.showtimes.push(showing);

    this.setState({ groupedTheaterScreens });
  }

  onDeleteTheaterScreenShowingClicked(showing) {
    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    let tmpItem = _.find(groupedTheaterScreens, { theaterId: showing.theaterId, screenId: showing.screenId });
    if (tmpItem) {
      let itemIdx = _.findIndex(tmpItem.showtimes, showing);
      if (itemIdx >= 0) {
        tmpItem.showtimes.splice(itemIdx, 1);
      }
    }

    this.setState({ groupedTheaterScreens });
  }

  onShowingTheaterChanged(showing, theaterId) {
    showing.theaterId = theaterId;

    // get default screen id
    let theater = this.getTheater(theaterId);
    showing.screenId = _.get(_.first(theater?.screens), 'id', null);

    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingScreenChanged(showing, screenId) {
    showing.screenId = screenId;
    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingMovieChanged(showing, movie) {
    showing.movieId = movie.id;
    showing._dbg_movieTitle = movie.title;

    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingGeneralDateRangeDatesEnabledChanged(showing, value) {

    if (value) {
      showing.customDateRange = true;
    } else {
      delete showing.customDateRange;

      let data = this.state.data;
      showing.startDate = data.daterangeStartMomentValue;
      showing.endDate = data.daterangeEndMomentValue;
    }

    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingGeneralDateRangeDatesChanged(showing, dates, dateStrings) {
    // console.log('onShowingMovieChanged - dateStrings: ', dateStrings);

    showing.startDate = this._convertToDateString(_.nth(dates, 0));
    showing.endDate = this._convertToDateString(_.nth(dates, 1));

    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingGeneralTimeChanged(showing, timeIdx, time) {
    // console.log('onShowingGeneralTimeChanged - timeIdx: ' + timeIdx + ', time: ', time);

    _.set(showing, ['generalShowtimes', timeIdx, 'time'], this._convertToTimeString(time));

    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  _getIs3DShowing(showing, timeIdx, defaultValue = false) {
    let value = _.get(showing, ['generalShowtimes', timeIdx, 'is3D'], defaultValue);
    return this._convertToBooleanValue(value);
  }

  onShowingGeneralTimeIs3DChanged(showing, timeIdx, e) {
    let is3D = _.get(e, 'target.checked', false);
    is3D = this._convertToBooleanValue(is3D);

    _.set(showing, ['generalShowtimes', timeIdx, 'is3D'], is3D);

    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingGeneralTimeLabelChanged(showing, timeIdx, e) {
    let value = _.get(e, 'target.value', null) || null;

    _.set(showing, ['generalShowtimes', timeIdx, 'timeLabel'], value);

    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingGeneralTimeDeleted(showing, timeIdx) {
    // console.log('onShowingGeneralTimeDeleted - timeIdx: ', timeIdx);

    showing.generalShowtimes.splice(timeIdx, 1);

    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingGeneralTimeAdded(showing) {
    // console.log('onShowingGeneralTimeAdded');

    let newShowtime = null;
    let lastShowtime = _.last(showing.generalShowtimes);
    if (lastShowtime) {
      lastShowtime = this._convertToMomentTimeValue((lastShowtime && lastShowtime.time)? lastShowtime.time: lastShowtime);
      newShowtime = moment(lastShowtime).add(120, 'minutes');
      let isSameDay = newShowtime.isSameOrBefore(lastShowtime, 'day');
      if (isSameDay) {
        newShowtime = this._convertToTimeString(newShowtime);
      } else {
        // if we moved to a new day, just set the new showtime to null
        newShowtime = null;
      }
    }

    showing.generalShowtimes.push(newShowtime);

    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingExceptionItemIs3DChanged(showing, itemIdx, e) {
    let is3D = _.get(e, 'target.checked', false);
    is3D = this._convertToBooleanValue(is3D);

    _.set(showing, ['showtimeExceptions', itemIdx, 'is3D'], is3D);
    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingExceptionItemDateChanged(showing, itemIdx, date) {
    _.set(showing, ['showtimeExceptions', itemIdx, 'date'], this._convertToDateString(date));
    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingExceptionItemTimeChanged(showing, itemIdx, time) {
    _.set(showing, ['showtimeExceptions', itemIdx, 'time'], this._convertToTimeString(time));
    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingExceptionItemTimeLabelChanged(showing, itemIdx, e) {
    let value = _.get(e, 'target.value', null) || null;

    _.set(showing, ['showtimeExceptions', itemIdx, 'timeLabel'], value);
    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingExceptionItemTypeChanged(showing, itemIdx, type) {
    _.set(showing, ['showtimeExceptions', itemIdx, 'type'], type);
    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingExceptionItemAdded(showing, itemIdx, v) {

    let lastShowing = _.last(showing.showtimeExceptions);

    let newShowing = {
      type: 'add',
      date: null,
      time: null,
      is3D: false
    };

    if (lastShowing) {
      if (lastShowing.date && lastShowing.time) {
        newShowing.date = lastShowing.date;

        let lastShowtime = this._convertToMomentTimeValue(lastShowing.time);
        let newShowtime = moment(lastShowtime).add(120, 'minutes');
        newShowing.time = this._convertToTimeString(newShowtime);
      }
    }

    showing.showtimeExceptions.push(newShowing);

    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onShowingExceptionItemDeleted(showing, itemIdx, v) {
    showing.showtimeExceptions.splice(itemIdx, 1);
    let groupedTheaterScreens = this.state.groupedTheaterScreens;
    this.setState({ groupedTheaterScreens });
  }

  onSaveClicked(e) {
    this.setState({ loaded: false, saving: true }, () => {
      let modelData = this.updateScheduleModelFromGroupedTheaterScreens(this.state.data, this.state.groupedTheaterScreens);
      api.schedules.save(modelData.id, modelData).then(res => {
        let newId = _.get(res, 'data.id');
        if (this.isAddMode() && newId) {
          this.props.history.push('/schedules/edit/' + newId);
        }
        this.setState({ id: newId, loaded: false, saving: false }, () => {
          this.invalidateScheduleData(true);
        });
      });
    });
  }

  onBackClicked(e) {
    this.props.history.push('/schedules');
  }

  onCancelClicked(e) {
    this.onBackClicked();
  }

  onDeleteClicked(e) {
    let modelData = _.cloneDeep(this.state.data);
    this.setState({ loaded: false, saving: true }, () => {
      api.schedules.remove(modelData.id).then(res => {
        this.props.history.push('/schedules');
      });
    });
  }

  renderSummary() {

    let data = this.state.data || {};
    let daterangeStr = this.movieHelper.formatLongDateRange(data.daterange_start, data.daterange_end);
    let stats = this.movieHelper.calcShowtimeStats(data);

    return (
      <div className="showtime-summary d-flex flex-column">
        <div className="daterange">{daterangeStr}</div>
        <div className="stats">
          {stats.numDays + ' ' + pluralize('days', stats.numDays)},&nbsp;
          {stats.numShowings + ' ' + pluralize('showings', stats.numShowings)},&nbsp;
          {stats.numMovies + ' ' + pluralize('movies', stats.numMovies)},&nbsp;
          {stats.numTheaters + ' ' + pluralize('theaters', stats.numTheaters)},&nbsp;
          {stats.numScreens + ' ' + pluralize('screens', stats.numScreens)}
        </div>
      </div>
    );
  };

  render() {

    let id = _.get(this, 'state.data.id') || _.get(this, 'state.id') || null;
    let sourceScheduleId = this.state.sourceScheduleId;
    let canDelete = !!id;

    let title = id? ('Edit Schedule ' + id): sourceScheduleId? ('Copy From Schedule ' + sourceScheduleId): 'Add Schedule';

    let titleActions = (
      <div className="title-actions">
        <Button type="default" size="large" icon={<FaIcon icon="fa-arrow-alt-left" />} onClick={this.onBackClicked}>Back</Button>
        <div className="title-text">{title}</div>
      </div>
    );

    let actions = (
      <div className="card-actions action-buttons">
        { canDelete? (
          <Popconfirm title="Are you sure you want to delete this schedule?"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={this.onDeleteClicked}>
            <Button type="danger" size="large" icon={<FaIcon icon="fa-trash" />}>Delete</Button>
          </Popconfirm>
        ) : null }
        <div className="ml-3">&nbsp;</div>
        <Button type="default" size="large" icon={<FaIcon icon="fa-times" />} onClick={this.onCancelClicked}>Cancel</Button>
        <Button type="primary" size="large" icon={<FaIcon icon="fa-check" />} onClick={this.onSaveClicked}>Save</Button>
      </div>
    );

    return (
      <div className="schedule-edit-view mx-auto">
        <Card title={titleActions} extra={actions}>
          <div className="page-content">
            { this.state.loaded? this.renderEditArea(): <LoadingSpinner /> }
          </div>
        </Card>
        { this.renderModals() }
      </div>
    );
  }

  renderEditArea() {
    return (
      <Form className="edit-schedule-content row" layout="vertical">
        <div className="details-area col-sm-12 col-12">
          { this.renderEditFormArea() }
        </div>
        {/* <div className="recent-movies-area col-sm-3 col-12">
          <RecentMovies onItemClicked={this.handleRecentMovieItemClicked} />
        </div> */}
      </Form>
    );
  }

  renderEditFormArea() {
    let data = this.state.data;
    let isAddMode = this.isAddMode();
    let isCopyMode = this.isCopyMode();

    let groupedTheaterScreens = this.state.groupedTheaterScreens;

    return (
      <div className="container-fluid">

        <div className="row">
          <div className="col-lg-6 col-md-9 col-12">
            { this.renderSummary() }
          </div>
          <div className="col-lg-3 col-md-3 col-12">
            <Form.Item label="Published Status" help={_.upperFirst(data.status)} colon={false}>
              <Switch checked={data.status === 'published'} onChange={this.onPublishedStatusChanged} />
            </Form.Item>
          </div>
          <div className="col-lg-3 col-md-12 col-12">
            { (isAddMode && !isCopyMode)? (
              <Form.Item label="Select Starting Template" colon={false}>
                <Input.Group compact className="d-flex flex-row fillx">
                  <Select className="flex-fill" value={this.state.selectedScheduleTemplate} onChange={this.onScheduleTemplateChanged}>
                    {_.map(this.state.scheduleTemplates, (item, idx) => {
                      return (<Select.Option key={idx} value={item.key}>{item.name}</Select.Option>);
                    })}
                  </Select>
                  <Button type="info" className="m-0 p-0" style={{ width: '120px' }} onClick={this.onPopuplateSelectedScheduleTemplateClicked}>
                    <span className="fas faw fa-magic"></span>
                  </Button>
                </Input.Group>
              </Form.Item>
            ): null }
          </div>
        </div>

        <div className="row pt-2">
          <div className="col-sm-4 col-12">
            <Form.Item label="Date Range" help={this._formatNumDays(data.daterangeStartMomentValue, data.daterangeEndMomentValue)} colon={false}>
              <DatePicker.RangePicker
                format={'ddd M/D/YYYY'}
                allowClear={false}
                value={[data.daterangeStartMomentValue, data.daterangeEndMomentValue]}
                onChange={this.onDateRangeDatesChanged} />
            </Form.Item>
          </div>
          <div className="col-sm-8 col-12">
            <Form.Item label="Optional Manager Notes" colon={false}>
              <Input.TextArea rows={3} value={data.manager_notes} onChange={this.onManagerNotesChanged} />
            </Form.Item>
          </div>
        </div>

        <div className="theater-showtimes pt-2">
          <div className="theater-showtimes-title">Theater Screen Showtime Schedules</div>

          {_.map(groupedTheaterScreens, (tmpItem, tmpItemIdx) => {

            return (
              <div className="theater-screen-showtimes" key={tmpItemIdx}>

                <div className="theater-screen-showtimes-header d-flex flex-row justify-content-between">
                  <div className="theater-screen-showtimes-title">Showings for { tmpItem.theaterName } - { tmpItem.screenName }</div>
                  <div className="theater-screen-showtimes-actions actions">
                    <Button type="primary" size="large" icon={<FaIcon icon="fa-plus" />} onClick={() => this.onAddTheaterScreenShowingClicked(tmpItem.theaterId, tmpItem.screenId)}>
                      Add
                    </Button>
                  </div>
                </div>

                <div className="theater-screen-showings">
                  { _.isEmpty(tmpItem.showtimes)? (
                      <div className="theater-screen-showing empty-showings-warning">There are no showings scheduled for this theater and screen.</div>)
                    : null }

                  { _.map(tmpItem.showtimes, (showing, showingIdx) => {
                    return (
                      <div key={showingIdx} className="theater-screen-showing">
                        { this.renderEditScreenShowingArea(showing) }
                      </div>
                    );
                  })}
                </div>

              </div>
            );
          })}

        </div>

        {/*
        <div className="row">
          <div className="col-sm-12 col-12">
            { (true && this.state.loaded)? this.renderJsonData(): null }
          </div>
        </div>
        */}

      </div>
    );
  }

  renderEditScreenShowingArea(showing) {
    let minDate = this.state.data.daterangeStartMomentValue;
    let maxDate = this.state.data.daterangeEndMomentValue;
    let fullScheduleDateRange = [minDate, maxDate];
    let movie = this.getMovie(showing.movieId) || { title: 'Movie ' + showing.movieId + ' loading...' };
    let theater = this.getTheater(showing.theaterId);

    let _isDateDisabled = (current) => {
      // can not select days before or after schedule range
      return (!current || !current.isBetween(minDate, maxDate, 'day', '[]'));
    };

    return (
      <div className="schedule-area d-flex flex-sm-row flex-column">
        <div className="preview-area d-flex flex-column">
          <MoviePosterImage movieId={showing.movieId} />
          <div className="movie-info center row">
            <div className="col-lg-6 col-sm-12 col-12"><span className="label">Movie ID: </span>{movie?.id}</div>
            <div className="col-lg-6 col-sm-12 col-12"><span className="label">Rating: </span>{movie?.rating}</div>
            <div className="col-lg-6 col-sm-12 col-12"><span className="label">Duration: </span>{this.movieHelper.formatDurationValue(movie?.durationMinsIntValue)}</div>
            <div className="col-lg-6 col-sm-12 col-12"><span className="label">Is 3D: </span>{movie?.is3DBooleanValue? 'Yes': 'No'}</div>
          </div>
        </div>

        <div className="showing-details-area fillx">
          <div className="container-fluid fillx">
            <div className="row">

              <div className="col-sm-10 col-12">
                <Form.Item label="Movie Title" colon={false}>
                  <MoviePicker selectedMovieId={showing?.movieId}
                               onSelectedMovieChanged={v => this.onShowingMovieChanged(showing, v)} />
                </Form.Item>
              </div>
              <div className="actions d-flex flex-row justify-content-end col-sm-2 col-12">
                <Button type="danger"
                        size="large"
                        icon={<FaIcon icon="fa-trash" />}
                        onClick={() => this.onDeleteTheaterScreenShowingClicked(showing)} />
              </div>

              <div className="col-sm-6 col-12">
                <Form.Item label="Theater" colon={false}>
                  <Select value={showing?.theaterId} onChange={v => this.onShowingTheaterChanged(showing, v)}>
                    {_.map(this.state.theaters, (theater, theaterIdx) => {
                      return (<Select.Option key={theaterIdx} value={theater.id}>{theater.name}</Select.Option>);
                    })}
                  </Select>
                </Form.Item>
              </div>

              <div className="col-sm-6 col-12">
                <Form.Item label="Screen" colon={false}>
                  <Select value={showing?.screenId} onChange={v => this.onShowingScreenChanged(showing, v)}>
                    {_.map(theater?.screens, (screen, screenIdx) => {
                      return (<Select.Option key={screenIdx} value={screen.id}>{screen.name}</Select.Option>);
                    })}
                  </Select>
                </Form.Item>
              </div>

              <div className="col-sm-6 col-12 d-flex flex-row justify-content-start align-items-center">
                <div className="mr-5">General Showtimes</div>
                <Switch checked={showing.customDateRange} onChange={v => this.onShowingGeneralDateRangeDatesEnabledChanged(showing, v)} />
                <div className="ml-1">Override Dates</div>
                {/* <Checkbox className="mx-3"
                            disabled={false}
                            checked={false}
                            onChange={e => this.onShowingGeneralDateRangeDatesEnabledChanged(showing, e.target.checked)}>Override Date Range</Checkbox> */}

              </div>

              <div className="col-sm-6 col-12">
                <Form.Item label="Date Range" help={this._formatNumDays(this._convertToMomentDateValue(showing.startDate), this._convertToMomentDateValue(showing.endDate))} colon={false}>
                  <DatePicker.RangePicker
                    format={'ddd M/D/YYYY'}
                    allowClear={false}
                    disabled={!showing.customDateRange}
                    value={[this._convertToMomentDateValue(showing.startDate), this._convertToMomentDateValue(showing.endDate)]}
                    onChange={(v1, v2) => this.onShowingGeneralDateRangeDatesChanged(showing, v1, v2)}
                    disabledDate={_isDateDisabled}
                    ranges={{
                      'Today': [moment(), moment()],
                      'Full Schedule': fullScheduleDateRange,
                    }}
                  />
                </Form.Item>
              </div>

              <div className="col-sm-12 col-12">
                <Form.Item label="Times" colon={false}>
                  {_.map(showing && showing.generalShowtimes, (timeObj, timeIdx) => {
                    let time = this._getShowtimeTime(timeObj);
                    let label = this._getShowtimeLabel(timeObj) || '';
                    let is3D = this._getShowtimeIs3D(timeObj, movie.is3DBooleanValue);
                    return (
                      <div key={timeIdx} className="general-showtime-time">
                        <TimePicker
                          use12Hours
                          format="h:mm A"
                          allowClear={false}
                          value={this._convertToMomentTimeValue(time)}
                          onChange={v => this.onShowingGeneralTimeChanged(showing, timeIdx, v)} />

                        <Input
                          className="time-label"
                          defaultValue={label}
                          placeholder="Enter Label"
                          onChange={e => this.onShowingGeneralTimeLabelChanged(showing, timeIdx, e)} />

                        <Checkbox className="mx-3"
                                  disabled={!theater.supports3DBooleanValue || !movie.is3DBooleanValue}
                                  checked={theater.supports3DBooleanValue && movie.is3DBooleanValue && is3D}
                                  onChange={e => this.onShowingGeneralTimeIs3DChanged(showing, timeIdx, e)}>Is 3D?</Checkbox>

                        <Button type="default"
                                size="default"
                                icon={<FaIcon icon="fa-times" />}
                                onClick={() => this.onShowingGeneralTimeDeleted(showing, timeIdx)} />
                      </div>
                    );
                  })}
                  <div className="general-showtime-time mt-3">
                    <Button className="w-50"
                            type="default"
                            size="default"
                            icon={<FaIcon icon="fa-plus" />}
                            onClick={() => this.onShowingGeneralTimeAdded(showing)}>
                      Add New Time
                    </Button>
                  </div>
                </Form.Item>
              </div>

              <div className="col-sm-12 col-12 mt-3">Additional Showtime Overrides</div>

              <div className="col-sm-12 col-12">
                {_.map(showing && showing.showtimeExceptions, (item, itemIdx) => {
                  return (
                    <div key={itemIdx} className="showtime-exception mt-2">
                      <DatePicker
                        format={'ddd M/D/YYYY'}
                        allowClear={false}
                        value={this._convertToMomentDateValue(item.date)}
                        onChange={v => this.onShowingExceptionItemDateChanged(showing, itemIdx, v)}
                        disabledDate={_isDateDisabled}
                        ranges={{
                          'Today': [moment(), moment()],
                          'Full Schedule': fullScheduleDateRange,
                        }}
                      />
                      <TimePicker
                        use12Hours
                        format="h:mm A"
                        allowClear={false}
                        value={this._convertToMomentTimeValue(item.time)}
                        onChange={v => this.onShowingExceptionItemTimeChanged(showing, itemIdx, v)} />

                      <Input
                        className="time-label"
                        defaultValue={this._getShowtimeLabel(item) || ''}
                        placeholder="Enter Label"
                        onChange={e => this.onShowingExceptionItemTimeLabelChanged(showing, itemIdx, e)}
                      />

                      <Select className="showing-exception-type-select ml-3" value={item.type} onChange={v => this.onShowingExceptionItemTypeChanged(showing, itemIdx, v)}>
                        <Select.Option value={'add'}>Add</Select.Option>
                        <Select.Option value={'remove'}>Remove</Select.Option>
                      </Select>

                      <Checkbox className="mx-3"
                                disabled={!theater.supports3DBooleanValue || !movie.is3DBooleanValue}
                                checked={theater.supports3DBooleanValue && movie.is3DBooleanValue && this._getShowtimeIs3D(item, movie.is3DBooleanValue)}
                                onChange={e => this.onShowingExceptionItemIs3DChanged(showing, itemIdx, e)}>Is 3D?</Checkbox>

                      <Button type="default"
                              size="default"
                              icon={<FaIcon icon="fa-times" />}
                              onClick={() => this.onShowingExceptionItemDeleted(showing, itemIdx)} />
                    </div>
                  );
                })}
                <div className="general-showtime-time mt-3 mb-3">
                  <Button className="w-50"
                          type="default"
                          size="default"
                          icon={<FaIcon icon="fa-plus" />}
                          onClick={() => this.onShowingExceptionItemAdded(showing)}>
                    Add New Showtime Exception
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderModals() {

    let _handleOk = () => {
      this.setState({ modalOpen: false, modalData: null });
    };
    let _handleCancel = () => {
      this.setState({ modalOpen: false, modalData: null });
    };

    let modalData = _.get(this.state, 'modalData') || {};
    return (
      <React.Fragment>
        <Modal
          title="Modify Showing Theater and Screen"
          visible={this.state.modalOpen}
          onOk={_handleOk}
          onCancel={_handleCancel}
        >
          <Form>
            <Form.Item label="Theater" colon={false}>
              <Select value={modalData?.showing?.theaterId} onChange={v => this.onShowingTheaterChanged(modalData?.showing, v)}>
                {_.map(this.state.theaters, (theater, theaterIdx) => {
                  return (<Select.Option key={theaterIdx} value={theater.id}>{theater.name}</Select.Option>);
                })}
              </Select>
            </Form.Item>

          </Form>
          <p>Some contents...</p>
          <p>Some contents...</p>
          <p>Some contents...</p>
        </Modal>
      </React.Fragment>
    );
  }

  renderJsonData() {
    let data = {
      data: this.state.data,
      theaters: this.state.theaters,
      movies: this.state.movies,
    };

    return (
      <pre>{ JSON.stringify(data, null, 2) }</pre>
    );
  }

  _convertToMomentDateValue(dateStr) {
    let retval = null;
    if (dateStr) {
      try {
        retval = moment(dateStr, ['YYYY-MM-DD', 'MM/DD/YYYY', 'M/DD/YYYY', 'M/D/YYYY']);
      } catch (ex) {
        if (!retval || !retval.isValid())
          retval = null;
      }
    }
    return retval;
  }

  _convertToDateString(value) {
    let datestr = null;
    if (value && value) {
      if (value && value.isValid()) {
        datestr = value.format('YYYY-MM-DD');   // iso date only (no time)
      }
    }
    return datestr;
  }

  _convertToMomentTimeValue(timeStr) {
    let retval = null;
    if (timeStr) {
      try {
        retval = moment(timeStr, ['hh:mm A', 'h:mm A', 'hh:mm a', 'h:mm a']);
      } catch (ex) {}
    }
    return retval;
  }

  _convertToTimeString(value) {
    let timestr = null;
    if (value && value) {
      if (value && value.isValid()) {
        timestr = value.format('h:mm A');
      }
    }
    return timestr;
  }

  _convertToBooleanValue(value) {
    if (_.isBoolean(value)) { return value; }
    return !!(_.toString(value) === '1');
  }

  _convertToBooleanString(value) {
    return (!!value)? '1': '0';
  }

  _formatNumDays(date1, date2) {
    let retval = null;
    if (date1 && date2) {
      let numDays = date2.diff(date1, 'day');
      numDays = Math.abs(numDays) + 1;
      retval = numDays + ' ' + pluralize('days', numDays)
    }
    return retval;
  }

  _getShowtimeTime(timeObj) {
    return _.get(timeObj, 'time', null);
  }

  _getShowtimeLabel(timeObj) {
    return _.get(timeObj, 'timeLabel', null);
  }

  _getShowtimeIs3D(timeObj, defaultValue = false) {
    let retval = _.get(timeObj, 'is3D', defaultValue);
    return this._convertToBooleanValue(retval);
  }

  _sortShowtimes(showtimes) {
    return _.sortBy(showtimes, v1 => {
      let time = this._convertToMomentTimeValue(v1.time);
      return (time && time.isValid())? time.valueOf(): null;
    });
  }

  _sortShowtimeExceptions(showtimes) {
    return _.sortBy(showtimes, v1 => {
      let time = this._convertToMomentTimeValue(v1.time);
      let datetime = this._convertToMomentDateValue(v1.date);
      datetime.set({
        hour: time.get('hour'),
        minute: time.get('minute'),
      });
      return (datetime && datetime.isValid())? datetime.valueOf(): null;
    });
  }

}



function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // setAuthState,
  // getAuthSessionStateToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduleEditView));

